export default __webpack_public_path__ + "static/media/caretUp.f2ebf24b.svg";